import {BackendApi} from '@/services/backend_api'

export const PARK_QUIZ_TEMPLATE_UUID = 'cec1cd60-db16-35ca-aa9f-ca2056b7b9bc'
export const PARK_QUIZ_STATUS_UNANSWERED = 'unanswered'
export const PARK_QUIZ_STATUS_ANSWERED = 'answered'
export const PARK_QUIZ_STATUS_WAITING_APPROVAL = 'waiting_approval'
export const PARK_QUIZ_STATUS_DISAPPROVED = 'disapproved'

export default {
  post (parkId, year) {
    return BackendApi.getClient().post('park-quizzes/', {parkId, year, quizTemplateUuid: PARK_QUIZ_TEMPLATE_UUID})
      .then(response => { return response })
      .catch(e => { throw e })
  },
  put (uuid, status, answers, axisToValidate = null) {
    return BackendApi.getClient().put(`park-quizzes/${uuid}`, { status, answers, axisToValidate })
      .then(response => { return response })
      .catch(e => { throw e })
  },
  getByYear (parkId, year) {
    return BackendApi.getClient().get(`park-quizzes/?park=${parkId}&year=${year}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  waittingApproval () {
    return BackendApi.getClient().get(`/waitting-approval-park-quizzes`)
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/park_quiz.js